import React, { useEffect, useMemo, useState } from "react";
import "./noticias.css";

function Noticias() {
    const [noticias, setNoticias] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [error, setError] = useState("");
    const [modalNoticia, setModalNoticia] = useState(null);

    const cargarNoticias = () => {
        setCargando(true);
        fetch("/api/noticias")
            .then((res) => {
                if (!res.ok) throw new Error("Error al obtener noticias");
                return res.json();
            })
            .then((data) => setNoticias(data))
            .catch((err) => setError(err.message))
            .finally(() => setCargando(false));
    };

    useEffect(() => {
        cargarNoticias();
    }, []);

    const ordenadas = useMemo(() => {
        const getDate = (n) => new Date(n.fecha || n.createdAt || 0).getTime();
        return [...noticias].sort((a, b) => getDate(b) - getDate(a));
    }, [noticias]);

    const ultima = ordenadas[0] || null;
    const resto = ultima ? ordenadas.slice(1, 5) : [];

    const imgSrc = (n) =>
        typeof n.imagen === "string" && /^https?:\/\//i.test(n.imagen)
            ? n.imagen
            : `/api/noticias/${n._id}/imagen?v=${n.updatedAt ? new Date(n.updatedAt).getTime() : Date.now()}`;

    // Bloquear scroll cuando el modal está abierto
    useEffect(() => {
        if (modalNoticia) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [modalNoticia]);

    if (cargando) return <div className="noticias-wrap">Cargando...</div>;
    if (error) return <div className="noticias-wrap error">{error}</div>;

    return (
        <div className="noticias-wrap">
            <div className="noticias-header">
                <h1 className="title">Noticias</h1>
            </div>

            <div className="noticias-grid">
                {ultima && (
                    <article className="noticia-card ultima" key={ultima._id}>
                        <div className="media">
                            {ultima.imagen ? (
                                <img alt={ultima.titulo} src={imgSrc(ultima)} />
                            ) : (
                                <div className="placeholder">Sin imagen</div>
                            )}
                        </div>
                        <div className="content center-content">
                            <h2 className="title">{ultima.titulo}</h2>
                            <div className="meta">
                                {ultima.fecha ? new Date(ultima.fecha).toLocaleDateString() : ""}
                            </div>
                            <button
                                className="btn-ver destacado"
                                onClick={() => setModalNoticia(ultima)}
                            >
                                Ver noticia completa
                            </button>
                        </div>
                    </article>
                )}

                {resto.map((n) => (
                    <article className="noticia-card" key={n._id}>
                        <div className="media">
                            {n.imagen ? (
                                <img alt={n.titulo} src={imgSrc(n)} />
                            ) : (
                                <div className="placeholder">Sin imagen</div>
                            )}
                        </div>
                        <div className="content">
                            <h3 className="title">{n.titulo}</h3>
                            <div className="meta">
                                {n.fecha ? new Date(n.fecha).toLocaleDateString() : ""}
                            </div>
                            <button className="btn-ver" onClick={() => setModalNoticia(n)}>
                                Ver noticia completa
                            </button>
                        </div>
                    </article>
                ))}
            </div>

            {modalNoticia && (
                <div className="modal-overlay show" onClick={() => setModalNoticia(null)}>
                    <div className="modal-content show" onClick={(e) => e.stopPropagation()}>
                        <button className="modal-close" onClick={() => setModalNoticia(null)}>
                            ✕
                        </button>

                        <h2>{modalNoticia.titulo}</h2>
                        <div className="meta">
                            {modalNoticia.fecha
                                ? new Date(modalNoticia.fecha).toLocaleDateString()
                                : ""}
                        </div>

                        {modalNoticia.imagen && (
                            <img
                                className="modal-img full"
                                alt={modalNoticia.titulo}
                                src={imgSrc(modalNoticia)}
                            />
                        )}

                        <div
                            className="modal-text"
                            dangerouslySetInnerHTML={{ __html: modalNoticia.texto }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

export default Noticias;
